import React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { setConditionOperator } from '../../../state';
import { useGetLogicalOperatorsQuery } from '../../../../../services/WorkflowService';
import { ConditionOperator } from '../../../../../services/WorkflowService';

export const LogicalOperatorSelect: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentWorkflow = useAppSelector((state) => state.workflow.currentWorkflow);
  const { data: logicalOperators = [], isLoading: loadingLogical } = useGetLogicalOperatorsQuery();

  if (!currentWorkflow) return null;

  return (
    <FormControl size="small" sx={{ minWidth: 120 }}>
      <Select
        value={currentWorkflow.conditionOperator}
        onChange={(e) => dispatch(setConditionOperator(e.target.value as ConditionOperator))}
        sx={{ fontSize: '0.875rem' }}
        disabled={loadingLogical}
      >
        {logicalOperators.map((op) => (
          <MenuItem key={op.value} value={op.value}>
            {op.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LogicalOperatorSelect;
